import styled, { css } from 'styled-components';

import Link from 'components/Link';
import Text from 'components/core/Text';
import colors from 'constants/colors';

interface CompactActivityViewProps {
  compact?: boolean;
}

const wrapperStyles = css<CompactActivityViewProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
  border-radius: 8px;

  &:hover {
    background-color: ${colors.main.secondaryBtns};
  }

  &:focus-visible {
    outline: 2px solid ${colors.main.blue};
    outline-offset: 2px;
  }

  @media screen and (max-width: 992px) {
    background-color: ${colors.main.secondaryBtns};
  }

  ${({ compact }) =>
    compact &&
    css`
      padding: 12px;
    `}
`;

export const Wrapper = styled(Link)<CompactActivityViewProps>`
  ${wrapperStyles}
`;

// External workouts don't link anywhere, so they get a plain container
export const StaticWrapper = styled.div<CompactActivityViewProps>`
  ${wrapperStyles}
`;

// Grows into the space beside the minutes column instead of pushing it onto its own line.
export const Main = styled.div`
  flex: 1 1 0;
  min-width: 0;

  // Phones stack the minutes under the content, as before.
  @media screen and (max-width: 400px) {
    flex-basis: 100%;
  }
`;

// Full-width last row of the card.
export const TagRow = styled.ul`
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
  gap: 6px;
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
`;

export const TagChip = styled.li`
  border: 1px solid ${colors.main.black};
  border-radius: 999px;
  color: ${colors.main.black};
  font-size: 12px;
  line-height: 1.4;
  padding: 2px 10px;
`;

export const PreviewWrapper = styled.div`
  display: flex;
`;

export const Metrics = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  height: min-content;
  gap: 8px;
`;

export const ExerciseMetrics = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  min-width: 64px;
  text-align: right;

  @media screen and (max-width: 400px) {
    width: 100%;
    padding-top: 16px;
    flex-direction: row;
    justify-content: space-around;
    text-align: center;
  }
`;

export const ProgramSession = styled(Text)<CompactActivityViewProps>`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: 5em;

  ${({ compact }) =>
    compact &&
    css`
      -webkit-line-clamp: 2;
      max-height: 3em;
    `}
`;

export const ProgramNameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const SessionDate = styled(Text)`
  padding: 4px 8px;
  border-radius: 8px;
  background-color: ${colors.main.secondaryBtns};
`;
export const Preview = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 16px;
  background-color: ${colors.main.secondaryBtns};
`;
